import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HotelSearchView from '../views/HotelSearchView.vue'
import HotelDetailsView from '../views/HotelDetailsView.vue'
import RoomDetailsView from '../views/RoomDetailsView.vue'
import RoomBookingView from '../views/RoomBookingView.vue'
import ErrorView from '../views/ErrorView.vue'
import NotFound from '../components/NotFound.vue'

const routes = [{
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/hotel-search',
        name: 'hotel-search',
        component: HotelSearchView
    },
    {
        path: '/hotel-details',
        name: 'hotel-details',
        component: HotelDetailsView
    },
    {
        path: '/room-details',
        name: 'room-details',
        component: RoomDetailsView
    },
    {
        path: '/room-booking',
        name: 'room-booking',
        component: RoomBookingView
    },
    {
        path: '/error',
        name: 'error',
        component: ErrorView
    },
    {
        path: '/:cathAll(.*)',
        name: 'NotFound',
        component: NotFound
    }
]

const scrollBehavior = (to, from, savedPosition) => {
    return savedPosition ||
        to.meta.scrollPos || {
            top: 0,
            left: 0
        }
}

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior,
})

router.beforeEach((to, from, next) => {
    from.meta.scrollPos && (from.meta.scrollPos.top = window.scrollY)
    return next()
})

export default router